import format from "date-fns/format";
import React, { useEffect } from "react";
import styled from "styled-components";
import PlatformIcons from "../../logos/social";
import PublicName from "../../utils/publicName";
import StarRating from "../StarRating";
import "../Review.scss";

const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 10000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
`;

const ModalContainer = styled.div`
  background: #fff;
  border-radius: 12px;
  max-width: 600px;
  width: 100%;
  max-height: 80vh;
  overflow-y: auto;
  padding: 32px;
  position: relative;
`;

const CloseButton = styled.button`
  position: absolute;
  top: 12px;
  right: 16px;
  background: none;
  border: none;
  font-size: 1.5em;
  cursor: pointer;
  color: #999;
  padding: 4px 8px;
  line-height: 1;

  &:hover {
    color: #404040;
  }
`;

const ModalTop = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 12px;
`;

const PlatformImg = styled.img`
  width: 28px;
  height: 28px;
  object-fit: contain;
`;

const NameDateWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

const AuthorName = styled.span`
  font-weight: 600;
  color: #404040;
  font-size: 1em;
`;

const ModalDate = styled.span`
  color: #999;
  font-size: 0.85em;
`;

const ModalComment = styled.p`
  color: #404040;
  font-size: 0.95em;
  line-height: 1.6;
  margin-top: 12px;
  white-space: pre-wrap;
`;

const Recommended = styled.div`
  color: #5b9bd5;
  font-size: 0.9em;

  i {
    margin-right: 4px;
  }
`;

const ReviewModal = ({ review, onClose }) => {
  const { name, created_at, rating, comment, platform, recommended } = review;
  const platformKey = platform || "FIRST_PARTY";

  useEffect(() => {
    const prevOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";

    const handleKeyDown = (e) => {
      if (e.key === "Escape") {
        onClose();
      }
    };
    document.addEventListener("keydown", handleKeyDown);

    return () => {
      document.body.style.overflow = prevOverflow;
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [onClose]);

  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <Overlay className="fdn-carousel-modal-overlay" onClick={handleOverlayClick}>
      <ModalContainer className="fdn-carousel-modal">
        <CloseButton className="fdn-carousel-modal-close" onClick={onClose}>
          &times;
        </CloseButton>
        <ModalTop className="fdn-carousel-modal-top">
          <PlatformImg
            className="fdn-carousel-modal-platform-icon"
            src={PlatformIcons[platformKey]}
            alt={platformKey}
          />
          <NameDateWrapper className="fdn-carousel-modal-name-date">
            <AuthorName className="fdn-carousel-modal-name">{name ? PublicName(name) : "Anonymous"}</AuthorName>
            <ModalDate className="fdn-carousel-modal-date">{format(created_at, "M/D/YYYY")}</ModalDate>
          </NameDateWrapper>
        </ModalTop>
        {platform === "FACEBOOK" ? (
          recommended ? (
            <Recommended>
              <i className="ion ion-checkmark" /> <span>Recommended</span>
            </Recommended>
          ) : null
        ) : (
          <StarRating rating={rating} className="fdn-rating-modal" />
        )}
        <ModalComment className="fdn-carousel-modal-comment">{comment}</ModalComment>
      </ModalContainer>
    </Overlay>
  );
};

export default ReviewModal;



// WEBPACK FOOTER //
// ./src/components/carousel/ReviewModal.jsx